import { formatNumber } from '@/shared/lib'
import type { CatalogText, ProductStock } from './types'

/**
 * Строковое поле каталога: значение при `state: 'ok'`, иначе `null` — экран рисует прочерк.
 * `missing` и `unreadable` различает бэк; пользователю в обоих случаях показывать нечего.
 */
export function textOf(field: CatalogText): string | null {
  return field.state === 'ok' ? field.value : null
}

/** Количество строкой бэка: целое показывается с разрядами, прочее — как пришло. */
export function quantityText(value: string): string {
  return /^-?\d+(\.\d+)?$/.test(value) ? formatNumber(Number(value)) : value
}

/** Уровень вместо скрытого остатка звёздочками, как старый портал (data.js:2349-2357). */
const AVAILABILITY_STARS: Record<NonNullable<ProductStock['availabilityLevel']>, string> = {
  'over-20': '∗ ∗ ∗ ∗',
  '11-20': '∗ ∗ ∗',
  '6-10': '∗ ∗',
}

/**
 * «Доступно к заказу» строкой: число (`availableToOrder`) с разрядами, либо — когда бэк его
 * скрыл (`null`) — уровень звёздочками (`availabilityLevel`). Оба `null` — показывать нечего.
 */
export function availableText(
  stock: Pick<ProductStock, 'availableToOrder' | 'availabilityLevel'>,
): string {
  if (stock.availableToOrder !== null) return quantityText(stock.availableToOrder)
  return stock.availabilityLevel !== null ? AVAILABILITY_STARS[stock.availabilityLevel] : ''
}
